export default "__VITE_ASSET__BVut7nRV__"